export const lightTheme = {
  isDark: false,
  primaryColor: 'rgb(0, 166, 90)',
  primaryColorHover: 'rgb(0, 133, 72)',
  secondaryColor: 'rgb(226, 64, 64)',
  secondaryColorHover: 'rgb(189, 53, 53)',
  backgroundColor: 'rgb(240, 241, 246)',
  textColor: '#131313',
  lightGray: '#e0e0e0',
  darkGray: '#757575',
  successColor: '#4caf50',
  successColorHover: '#388e3c',
  warningColor: '#ff9800',
  warningColorHover: '#e08c00',
  errorColor: '#f44336',
  errorColorHover: '#d32f2f',
  dangerColor: '#e53e3e',
  dangerColorHover: '#c53030',
  white: '#ffffff',
  black: '#000000',
  infoColor: '#2196f3',
  infoColorHover: '#1e88e5',
  defaultColor: '#4299e1',
  defaultColorHover: '#3182ce',
  defaultColorShadow: 'rgba(0, 123, 255, 0.25)',
  borderColor: '#e2e8f0',
  darkColor: '#2d3748',
  darkColorHover: '#1e293b',
  darkColorLight: '#4a5568',
  darkColorLightHover: '#333',
  lightColor: '#f1f5f9',
  lightGrayColor: '#f5f5f5',
  lightGrayHover: '#e0e0e0',
  cardBackground: '#ffffff',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  tableHeaderBackground: '#f5f5f5',
  tableHeaderText: '#2d3748',
  tableHoverBackground: '#f0f0f0',
  expandedRowBackground: '#e6f7ff',
  subRowBackground: '#f5f5f5',
  iconColor: '#4a5568',
  inputBackground: '#ffffff',
  expandButtonHoverBackground: 'rgba(0, 0, 0, 0.05)',
  expandedContentBackground: '#f9f9f9',
  subTableHeaderBackground: '#eaeaea',
  gray: '#6c757d',
  dangerLightColor: '#ffeeee',
  primaryDarkColor: '#0056b3',
};

export const darkTheme = {
  isDark: true,
  primaryColor: 'rgb(0, 128, 70)',
  primaryColorHover: 'rgb(0, 100, 55)',
  secondaryColor: 'rgb(185, 40, 40)',
  secondaryColorHover: 'rgb(150, 30, 30)',
  backgroundColor: '#323232',
  textColor: '#f5f5f5',
  lightGray: '#2c2c2c',
  darkGray: '#a0a0a0',
  successColor: '#2e7d32',
  successColorHover: '#1b5e20',
  warningColor: '#e65100',
  warningColorHover: '#bf360c',
  errorColor: '#c62828',
  errorColorHover: '#b71c1c',
  dangerColor: '#c53030',
  dangerColorHover: '#9b2c2c',
  white: '#1a1a1a',
  black: '#f5f5f5',
  infoColor: '#0d47a1',
  infoColorHover: '#01579b',
  defaultColor: '#1976d2',
  defaultColorHover: '#0d47a1',
  defaultColorShadow: 'rgba(0, 60, 153, 0.25)',
  borderColor: '#444',
  darkColor: '#f1f5f9',
  darkColorHover: '#e2e8f0',
  darkColorLight: '#cbd5e0',
  darkColorLightHover: '#a0aec0',
  lightColor: '#323232',
  lightGrayColor: '#2c2c2c',
  lightGrayHover: '#3c3c3c',
  cardBackground: '#2c2c2c',
  shadowColor: 'rgba(0, 0, 0, 0.3)',
  tableHeaderBackground: '#3c3c3c',
  tableHeaderText: '#f5f5f5',
  tableHoverBackground: '#3a3a3a',
  expandedRowBackground: '#2d4052',
  subRowBackground: '#333333',
  iconColor: '#a0aec0',
  inputBackground: '#1a1a1a',
  expandButtonHoverBackground: 'rgba(255, 255, 255, 0.1)',
  expandedContentBackground: '#333333',
  subTableHeaderBackground: '#3c3c3c',
  gray: '#a0a0a0',
  dangerLightColor: '#5a2828',
  primaryDarkColor: '#1e88e5',
};
